import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReportsService } from '../../Services/reports/reports.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-approval-status-report',
  templateUrl: './approval-status-report.component.html',
  styleUrls: ['./approval-status-report.component.css'],
  providers: [DatePipe]
})
export class ApprovalStatusReportComponent implements OnInit {
  loader: string = 'none';
  constructor(private reportsService:ReportsService,private snackBar:MatSnackBarComponent, private router: Router, private datepipe: DatePipe,private toastr: ToastrService) { }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
  }

    downloadApprovalStatusReport() {
    this.loader = 'block';
    this.reportsService.getApprovalStatusReport('')
      .subscribe(
        success => {
          var date=new Date();
          let latest_date =this.datepipe.transform(date, 'dd-MMM-yy')
          let name =localStorage.getItem('mcmt_userName').split(' ');
          let firstname=name[0];
          let lastName=name[1];
          let excelName=firstname+'_'+lastName + '_ApprovalStatusReport_'+latest_date+'.xlsx';
          saveAs(success, excelName);

          this.loader = 'none';
        },
        err => {
          this.toastr.error("No record/s available");
          //this.snackBar.openSnackBar("No record/s available", 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      );
  }
}
